import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { RoleCreate } from '@/pages/RoleCreate';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-roles/new'
)({
  component: RoleCreatePage,
});

function RoleCreatePage() {
  return (
    <>
      <Header
        enableBack
        fallbackTo="/admin/manage-roles"
        additionalClasses="bg-slate-700"
      />
      <RoleCreate />
    </>
  );
}
